// Trailing action-column width, shared by the row and the header so they align.
const productListActionColumnWidth = () => 140;

export default productListActionColumnWidth;
